export default {
  coplaca: ['produccion_integrada', 'unegap'],
}
